"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USE_GOOGLE_TRANSLATE = exports.USER_INFO_ENDPOINT = exports.STORE_PAGE = exports.PROPOSITIONS_USED = exports.PRODUCTS_LIST_FIELDS = exports.PRODUCTS_ENDPOINT = exports.NAME_ORDER_IN_CHAT = exports.MASK_PHONE_NUMBER_IN_CHAT = exports.MAIN_CHAT_COLOR = exports.HANDLE_PROPOSITION_DESIGN = exports.EMITTED_BY_BUYER = exports.DEFAULT_LOCALE = exports.CHAT_PER_PAGE = exports.CART_ITEMS_ENDPOINT = exports.BASE_URL = exports.BASE_API_URL = void 0;
var _Utils = require("react-platform-components/dist/Utils");
var BASE_URL = (0, _Utils.getBackendConfig)("REACT_BASE_URL", process.env.REACT_APP_BASE_URL);
exports.BASE_URL = BASE_URL;
var BASE_API_URL = (0, _Utils.getBackendConfig)("REACT_BASE_API_URL", process.env.REACT_APP_BASE_API_URL);
exports.BASE_API_URL = BASE_API_URL;
var MAIN_CHAT_COLOR = process.env.REACT_APP_MAIN_CHAT_COLOR || "#3f65b5";
exports.MAIN_CHAT_COLOR = MAIN_CHAT_COLOR;
var USE_GOOGLE_TRANSLATE = (0, _Utils.getBackendConfig)("REACT_USE_GOOGLE_TRANSLATE", process.env.REACT_APP_USE_GOOGLE_TRANSLATE || false);
exports.USE_GOOGLE_TRANSLATE = USE_GOOGLE_TRANSLATE;
var DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE || "fr";
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var STORE_PAGE = process.env.REACT_APP_STORE_PAGE || "stores";
//N==Nom P==Prénom ,on les ordonne dans une variable d'environnement dans l'ordre qu'on veut avoir sur le nom affiché
//la valeur par défaut est NP (si pas montionnée dans l'env)
exports.STORE_PAGE = STORE_PAGE;
var NAME_ORDER_IN_CHAT = process.env.REACT_APP_NAME_ORDER_IN_CHAT || "NP";
exports.NAME_ORDER_IN_CHAT = NAME_ORDER_IN_CHAT;
var CHAT_PER_PAGE = parseInt(process.env.REACT_APP_CHAT_PER_PAGE || 12);
exports.CHAT_PER_PAGE = CHAT_PER_PAGE;
var CART_ITEMS_ENDPOINT = process.env.REACT_APP_ITEMS_ENDPOINT || 'cartitems';
exports.CART_ITEMS_ENDPOINT = CART_ITEMS_ENDPOINT;
var PRODUCTS_ENDPOINT = process.env.REACT_APP_PRODUCTS_ENDPOINT || "static-product";
exports.PRODUCTS_ENDPOINT = PRODUCTS_ENDPOINT;
var USER_INFO_ENDPOINT = process.env.REACT_APP_USER_INFO_ENDPOINT || "users";
exports.USER_INFO_ENDPOINT = USER_INFO_ENDPOINT;
var EMITTED_BY_BUYER = process.env.REACT_APP_PROPOSITION_EMITTED_BY_BUYER || false;
exports.EMITTED_BY_BUYER = EMITTED_BY_BUYER;
var PRODUCTS_LIST_FIELDS = process.env.REACT_APP_PRODUCTS_LIST_FIELDS ? JSON.parse(process.env.REACT_APP_PRODUCTS_LIST_FIELDS) : [];
exports.PRODUCTS_LIST_FIELDS = PRODUCTS_LIST_FIELDS;
var PROPOSITIONS_USED = process.env.REACT_APP_PROPOSITIONS_USED_IN_CHAT || false;
exports.PROPOSITIONS_USED = PROPOSITIONS_USED;
var HANDLE_PROPOSITION_DESIGN = process.env.REACT_APP_HANDLE_PROPOSITION_DESIGN || false;
exports.HANDLE_PROPOSITION_DESIGN = HANDLE_PROPOSITION_DESIGN;
var MASK_PHONE_NUMBER_IN_CHAT = process.env.REACT_APP_MASK_PHONE_NUMBER_IN_CHAT || false;
exports.MASK_PHONE_NUMBER_IN_CHAT = MASK_PHONE_NUMBER_IN_CHAT;